<template>
    <v-card>
        <v-card-text>
            <table x:str border="0" cellpadding="2" style="border-collapse: collapse; margin-left: 0; margin-right: 2"
                height="450" width="730">
                <tr height="39" style="height: 29.25pt">
                    <td
                        style="height: 11; width: 728; font-size: 11.0pt; font-family: 'Times New Roman', serif; white-space: normal; color: windowtext; font-weight: 400; font-style: normal; text-decoration: none; text-align: general; vertical-align: bottom; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px">
                        <b>
                            <font face="Arial" color="#666666" size="4">DOCUMENTOS
                                DEL SGI MÁS UTILIZADOS POR SST</font>
                        </b>
                    </td>
                </tr>
                <tr height="39" style="height: 29.25pt">
                    <td
                        style="height: 11; width: 728; font-size: 11.0pt; font-family: 'Times New Roman', serif; white-space: normal; color: windowtext; font-weight: 400; font-style: normal; text-decoration: none; text-align: general; vertical-align: bottom; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px">
                        <img border="0" src="../../../public/images/DOCSGI.jpg" width="868" height="160">
                    </td>
                </tr>
                <tr>
                    <td style="height: 23; color: white; font-size: 11.0pt; font-weight: 700; font-family: Arial, sans-serif; text-align: left; vertical-align: middle; font-style: normal; text-decoration: none; white-space: nowrap; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px; background: green"
                        width="728">
                        <font size="3">&nbsp;PROCEDIMIENTOS</font>
                    </td>
                </tr>
                <tr v-for="item in procedimientos" :key="item.codigo" height="39" style="height: 29.25pt">
                    <td
                        style="height: 36px; width: 728px; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; vertical-align: bottom; border: none; padding: 1px">
                        <font size="3">
                            &nbsp;
                            <a :href="`https://api.icssa.com.ar/SGI/Documentos/${item.codigo}.pdf?` + Math.random()"
                                target="_blank">
                                {{ item.codigo }}:
                            </a>
                            {{ item.descripcion }}.
                        </font>
                    </td>
                </tr>
                <tr>
                    <td
                        style="height: 19; width: 728; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; font-style: normal; text-decoration: none; vertical-align: bottom; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px">
                        &nbsp;</td>
                </tr>
                <tr>
                    <td style="height: 23; color: white; font-size: 11.0pt; font-weight: 700; font-family: Arial, sans-serif; text-align: left; vertical-align: middle; font-style: normal; text-decoration: none; white-space: nowrap; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px; background: green"
                        width="728">
                        <font size="3">&nbsp;INSTRUCCIONES</font>
                    </td>
                </tr>
                <tr v-for="item in instrucciones" :key="item.codigo" height="39" style="height: 29.25pt">
                    <td
                        style="height: 36px; width: 728px; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; vertical-align: bottom; border: none; padding: 1px">
                        <font size="3">
                            &nbsp;
                            <a :href="`https://api.icssa.com.ar/SGI/Documentos/${item.codigo}.pdf?` + Math.random()"
                                target="_blank">
                                {{ item.codigo }}:
                            </a>
                            {{ item.descripcion }}.
                        </font>
                    </td>
                </tr>
            </table>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    name: "ListaInstrucciones",
    data() {
        return {
            procedimientos: [
                { "codigo": "MP5.04.03", "descripcion": "Programa SOL" },
                { "codigo": "MP6.01.02", "descripcion": "Gestión de riesgos y oportunidades" },
                { "codigo": "MP8.03.01", "descripcion": "Gestión de no conformidades" },
                { "codigo": "MP8.05.01", "descripcion": "Gestión de mejoras." },
                { "codigo": "MP8.05.02", "descripcion": "Acciones correctivas" }
            ],
            instrucciones: [
                { "codigo": "MI4.02.01.01", "descripcion": "Archivo general" },
                { "codigo": "MI4.02.01.02", "descripcion": "Sistema de back-up y almacenamiento de datos" },
                { "codigo": "MI5.04.02.01", "descripcion": "Formación de brigada contra incendios" },
                { "codigo": "MI5.04.02.02", "descripcion": "Plan de emergencias" },
                { "codigo": "MI5.04.02.03", "descripcion": "Atención de accidentes de trabajo" },
                { "codigo": "MI5.04.02.04", "descripcion": "Primeros auxilios" },
                { "codigo": "MI5.04.02.05", "descripcion": "Formación de brigada de emergencias y socorro" },
                { "codigo": "MI5.05.01.01", "descripcion": "Sistema de Telecomunicaciones" },
                { "codigo": "MI6.03.01.04", "descripcion": "Señalizaciones" },
                { "codigo": "MI8.01.01.01", "descripcion": "Guía para la gestión de la economía de la calidad, medio ambiente y SySO" },
            ]
        };
    }
};
</script>